/**
 * Created by SHO
 */

import { ZeroBetController } from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import { ParsedServerData } from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";

export interface ZeroBetConfig {
    type:zeroBetTypes;
    modes:string[];
}

export enum zeroBetTypes {
    ZERO_BET = "zerobet",
    PICK_AND_CLICK = "pickbet",
}

export class PunkZeroController extends ZeroBetController {

    private _config:ZeroBetConfig;
    subtractFreespinCounter(): boolean{return true};
    showFreespinCounter(): boolean{return true};

    shouldShowZeroBetCounter():boolean{return true};
    shouldSubtractZeroBetCounter():boolean{return true};
    getZeroBetNumberLeft(data: ParsedServerData): number{return data.freespinsLeft};

    constructor(config:ZeroBetConfig) { super(); this._config = config; }

    protected calculateIsTriggered(data:ParsedServerData):boolean{
        return this._config.modes.indexOf(data.nextMode) >= 0;
    };
}